import swal from "sweetalert";
import "./SweetAlert.css";
import enroll from "../../assets/images/enroll.png";

const APP_ALERT_CLASS = "app-swal-modal";

const showAppAlert = ({
  title,
  text,
  icon = "info",
  confirmText = "OK",
  cancelText = "Cancel",
  showCancel = false,
  dangerMode = false,
  content,
  closeOnClickOutside = true,
  closeOnEsc = true,
  useArrayButtons = false,
}) => {
  const options = {
    title,
    text,
    icon,
    dangerMode,
    className: APP_ALERT_CLASS,
    closeOnClickOutside,
    closeOnEsc,
  };

  if (content) {
    options.content = content;
  }

  if (showCancel) {
    options.buttons = useArrayButtons
      ? [cancelText, confirmText]
      : {
        cancel: cancelText,
        confirm: confirmText,
      };
  } else {
    options.button = confirmText;
  }

  return swal(options);
};

const sweetAlert = (
  title = "Are you sure?",
  text = "You want to close before saving!",
  icon = "warning",
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(false);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetConfirmAlert = (
  title = "Are you sure?",
  text = "You won't be able to revert this!",
  icon = "warning",
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(true);
        }
        else {
          reject();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetConfirmAlertWithChecklist = () => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title: "Please confirm the following before review completion",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <div style="
              text-align:left;
              width:100%;
              max-width:600px;
              padding:20px;
              font-family: Arial, sans-serif;
              line-height:1.8;
            ">
              <p style="margin:0 0 12px 0 ;"><b>1.)</b> I have commented on whether the content is <b>original</b> (not copied or extracted).</p>
              <p style="margin:12px 0 12px 0;"><b>2.)</b> I have mentioned the <b>lesson / syllabus unit</b> the question belongs to.</p>
              <p style="margin:12px 0 12px 0;"><b>3.)</b> I have checked <b>spelling and grammar</b>.</p>
              <p style="margin:12px 0 12px 0"><b>4.)</b> I have stated the <b>difficulty level</b> of the question (Easy / Medium / Hard).</p>
            </div>
          `,
        },
      },
      icon: "warning",
      confirmText: "Yes",
      cancelText: "Cancel",
      showCancel: true,
      useArrayButtons: true,
      closeOnClickOutside: true,
      closeOnEsc: true,
      dangerMode: false,
    })
      .then((isConfirmed) => {
        if (isConfirmed === true) {
          resolve(true);
        } else {
          reject(new Error("Review confirmation cancelled"));
        }
      })
      .catch((error) => reject(error));
  });
};


const sweetApproveAlert = (title, text, icon) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText: "Yes",
      cancelText: "No",
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(false);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetBlockSaveAlert = (
  title = "You have unsaved changes",
  text = "Are you sure you want to save before closing?",
  icon = enroll,
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      dangerMode: false,
    })
      .then((willEnroll) => {

        if (willEnroll) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetStatusAlert = (title, text, iconOf) => {
  const icon = iconOf ? iconOf : "error";
  return showAppAlert({ title, text, icon, dangerMode: false, confirmText: "OK" });
};

const sweetSuccessAlert = (title, text, iconOf, buttonText = "OK") => {
  const icon = iconOf ? iconOf : "success";
  return showAppAlert({ title, text, icon, confirmText: buttonText, dangerMode: false });
};

const registersuccess = (title, text, icon, callback, buttonText = "OK") => {
  showAppAlert({
    title,
    text,
    icon,
    confirmText: buttonText,
    dangerMode: false,
  }).then((result) => {
    if (callback && typeof callback === "function") {
      callback(result);
    }
  });
};

const sweetErrorAlert = (title, text) => {
  showAppAlert({
    icon: "error",
    title,
    text,
    confirmText: "OK",
  });
};

const sweetAlertEnroll = (
  title = "Are you sure?",
  text = "Are you sure you want to enroll to this exam ?",
  icon = enroll,
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willEnroll) => {
        resolve(!!willEnroll);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetAlertTryagain = (
  title = "Are you sure?",
  text = "Are you sure you want to try again for this exam ?",
  icon = enroll,
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willEnroll) => {
        resolve(!!willEnroll);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const sweetStudentRemoveAlert = (
  title = "Are you sure?",
  text = "This student will prevent access to this chat!",
  icon = "warning",
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(true);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetStudentAddAlert = (
  title = "Are you sure?",
  text = "This student will add to the chat!",
  icon = "info",
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(true);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetChatRenameAlert = (
  title = "Are you sure?",
  text = "Do you want to change chat name?",
  icon = "info",
  confirmText = "Yes",
  cancelText = "No"
) => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText,
      cancelText,
      showCancel: true,
      useArrayButtons: true,
      dangerMode: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          resolve(true);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sweetAlertInfo = (title, text, icon = "info", buttonText = "Okay") => {
  return new Promise((resolve, reject) => {
    showAppAlert({
      title,
      text,
      icon,
      confirmText: buttonText,
      dangerMode: false,
    })
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export default sweetAlert;
export {
  showAppAlert,
  sweetStatusAlert,
  sweetSuccessAlert,
  sweetErrorAlert,
  sweetAlertEnroll,
  registersuccess,
  sweetConfirmAlert,
  sweetApproveAlert,
  sweetStudentRemoveAlert,
  sweetStudentAddAlert,
  sweetChatRenameAlert,
  sweetAlertTryagain,
  sweetAlertInfo,
  sweetBlockSaveAlert,
  sweetConfirmAlertWithChecklist
};
